import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Swipeable, EventData } from "react-swipeable";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import { IImage } from "../../../models/Image";
import VideoPlayer from "./VideoPlayer";
// import ShareComponent, { ShareProps } from "../Share.tsx__";
import { getRandomInt, getViewImageLink } from "../../../utils";
import UIModal from "../UIModal";
import DescriptionText from "../../../laco-common/components/DescriptionText";
import { FileType } from "../../../laco-common/base/models/IFile";
import "./MediaOverlay.scss";


export type GalleryProps = {
	galleryImages?: IImage[];
	selectedMediaIndex?: number;
};

export type MediaOverlayProps = {
	displayMedia: boolean;
	onClose: any;
	selectedMedia: IImage;
	displayShare: boolean;
} & GalleryProps;

type MediaOverlayState = {
	displayMedia: boolean;
	selectedMedia: IImage;
	selectedMediaIndex?: number;
	routing?: boolean;
};

class MediaOverlay extends Component<MediaOverlayProps & RouteComponentProps, MediaOverlayState> {
	private videoElId: string = "mss-video-player" + getRandomInt(999);
	private historySub: any;

	state = {
		displayMedia: false,
		selectedMedia: null,
		selectedMediaIndex: this.props.selectedMediaIndex || 0,
		routing: false,
	};

	get hasNext(): boolean {
		return this.props.galleryImages && this.props.galleryImages.length > 1;
	}

	get hasPrev(): boolean {
		return this.props.galleryImages && this.props.galleryImages.length > 1;
	}

	componentDidMount() {
		if (this.props.displayMedia) {
			this.setState({ displayMedia: true });
		}
	}

	componentWillReceiveProps(nextProps: MediaOverlayProps) {
		// console.log("componentWillReceiveProps nexProps:", nextProps);
		if (
			nextProps.displayMedia != this.state.displayMedia ||
			nextProps.selectedMedia != this.state.selectedMedia ||
			(nextProps.selectedMedia &&
				this.state.selectedMedia &&
				nextProps.selectedMedia.url != this.state.selectedMedia.url)
		) {
			this.setState(nextProps);
		}
	}

	componentWillUnmount() {
		if (this.state.routing) return;
		if (this.historySub) this.historySub();
		this.closeOverlay();
	}

	closeOverlay() {
		this.props.onClose();
		this.setState({ displayMedia: false });
		const video: any = document.getElementById(this.videoElId);
		if (video) {
			video.pause();
		}
		this.props.history.replace({
			pathname: this.props.location.pathname,
			search: "close=1",
		});
	}

	onNext() {
		let nextIndex: number = this.state.selectedMediaIndex + 1;
		if (nextIndex >= this.props.galleryImages.length) {
			nextIndex = 0;
		}
		this.setState({
			selectedMediaIndex: nextIndex,
			selectedMedia: this.props.galleryImages[nextIndex],
			routing: true,
		});
		this.props.history.replace({
			pathname: this.props.location.pathname,
			search: `?${getViewImageLink(this.props.galleryImages[nextIndex].filename)}`,
		});
	}

	onPrev() {
		let prevIndex: number = this.state.selectedMediaIndex - 1;
		if (prevIndex < 0) {
			prevIndex = this.props.galleryImages.length - 1;
		}
		this.setState({
			selectedMediaIndex: prevIndex,
			selectedMedia: this.props.galleryImages[prevIndex],
			routing: true,
		});
		this.props.history.replace({
			pathname: this.props.location.pathname,
			search: `?viewImage=${this.props.galleryImages[prevIndex].filename}`,
		});
	}

	renderFullScreenMedia() {
		if (!this.state.selectedMedia) return null;
		if (this.state.selectedMedia.fileType == FileType.VIDEO) {
			return (
				<VideoPlayer width={"100%"} video={this.state.selectedMedia} videoId={this.videoElId} autoPlay={true} />
			);
		} else {
			return (
				<img
					src={this.state.selectedMedia.url}
					title={this.state.selectedMedia.title}
					alt={this.state.selectedMedia.title}
				></img>
			);
		}
	}

	render() {
		const media: IImage = this.state.selectedMedia;
		if (!media) return null;
		// let shareProps: ShareProps = {};
		// if (this.props.displayShare) {
		// 	if (this.props.entity) {
		// 		shareProps.url =
		// 			window.location.origin +
		// 			getEntityUrl(this.props.entity) +
		// 			"?" +
		// 			getViewImageLink(this.state.selectedMedia.filename);
		// 	} else {
		// 		shareProps.url =
		// 			window.location.origin +
		// 			window.location.pathname +
		// 			"?" +
		// 			getViewImageLink(this.state.selectedMedia.filename);
		// 	}

		// 	shareProps.mediaType = this.state.selectedMedia.fileType;
		// 	shareProps.metaImage = this.state.selectedMedia.thumbUrl || "";
		// 	shareProps.metaFile = this.state.selectedMedia.url;
		// 	shareProps.metaTitle = this.state.selectedMedia.title || "";
		// 	shareProps.metaDesc = this.state.selectedMedia.desc || "";
		// }

		// console.debug("MEDIA SHARE PROPS:", shareProps);
		console.debug("selected media:", media);

		return (
			<UIModal
				title={media.title || " "}
				pageTitle={media.title}
				className="image-fullscreen-overlay"
				contentClassName="ui-modal-content-fullscreen"
				open={this.state.displayMedia}
				onClose={() => this.closeOverlay()}
				showCloseIcon={true}
				noPadding={true}
				noContainer={true}
			>
				<>
					<Swipeable
						onSwipedLeft={this.hasPrev ? (e: EventData) => this.onPrev() : undefined}
						onSwipedRight={this.hasNext ? (e: EventData) => this.onNext() : undefined}
					>
						<div className="media-content">
							{this.renderFullScreenMedia()}

							{this.hasNext && (
								<IconButton
									edge="start"
									color="default"
									className="icon-btn-outlined float-right page-arrow-btn page-next-btn"
									onClick={(e) => {
										e.preventDefault();
										this.onNext();
									}}
								>
									<ArrowForwardIcon />
								</IconButton>
							)}
							{this.hasPrev && (
								<IconButton
									edge="start"
									color="default"
									className="icon-btn-outlined float-left page-arrow-btn page-prev-btn"
									onClick={(e) => {
										e.preventDefault();
										this.onPrev();
									}}
								>
									<ArrowBackIcon />
								</IconButton>
							)}
						</div>
						{/* {this.props.displayShare && (
							<ShareComponent
								className="mss-small-btn"
								url={shareProps.url}
								mediaType={shareProps.mediaType}
								metaImage={shareProps.metaImage}
								metaFile={shareProps.metaFile}
								metaTitle={shareProps.metaTitle}
								metaDesc={shareProps.metaDesc}
							></ShareComponent>
						)} */}
						<React.Fragment>
							{/* {this.state.selectedMedia.title && (
							<h3 className="text-left text-uppercase mb-1">{this.state.selectedMedia.title}</h3>
						)} */}
							<p className="image-desc text-left mt-3">
								<DescriptionText text={media.desc} />
							</p>
						</React.Fragment>
						{this.props.children}
					</Swipeable>
				</>
			</UIModal>
		);
	}
}

export default withRouter(MediaOverlay);
